import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  metersNoPlacementDetails: {
    id: 'app.inventory.meters.noPlacementDetails',
  },
  todayBuildingsInLocation: {
    id: 'app.inventory.today.buildingsInLocation',
  },
  todayRecentMeters: {
    id: 'app.inventory.today.recentMeters',
  },
  todayLoadingRecentMeters: {
    id: 'app.inventory.today.loadingRecentMeters',
  },
  todayLocalDrafts: {
    id: 'app.inventory.today.localDrafts',
  },
  todayLocalPhotoStorageWarning: {
    id: 'app.inventory.today.localPhotoStorageWarning',
  },
  todayMetersInLocation: {
    id: 'app.inventory.today.metersInLocation',
  },
  todayNoRecentMeters: {
    id: 'app.inventory.today.noRecentMeters',
  },
  todayRefreshingLocationStats: {
    id: 'app.inventory.today.refreshingLocationStats',
  },
  todayStartPasport: {
    id: 'app.inventory.today.startPasport',
  },
});
